<template>
  <div
    v-check-visible-viewport="onVisibleInViewport"
    :class="[{'container no-padding' : featuredImages.length < 3}, 'featured-carousel']"
  >
    <flickity
      ref="flickity"
      :options="flickityOptions"
      :class="[{'mt16' : featuredImages.length > 2}]">
      <div
        v-for="(item, index) in featuredImages"
        :class="featuredImages.length < 3 ? 'full-width' : ''"
        :key="index"
        :title="item.title"
        :data-segment-uuid="item.uuid"
        class="img-container">

        <PremiumLogo
          v-if="item.is_exclusive"
        />
        <picture-component
          :src="item.display_image_url"/>

        <div class="featured-content">
          <!-- Season {{ (item.season && item.season.number) || 0 }} : -->
          <!-- <p class="premier">Premier</p>
          <p class="show_name"> {{ item.title }}</p> -->
        </div>
      </div>
    </flickity>
  </div>
</template>
<script>
import * as log from 'loglevel';
import Flickity from 'vue-flickity';
import imgPlaceholder from '../assets/images/placeholder.png';
import PremiumLogo from './PremiumLogo';
import CarouselMixin from '../shared/carouselMixin';

export default {
  name: 'FeaturedCarousel',
  components: {
    Flickity,
    PremiumLogo,
  },
  mixins: [CarouselMixin],
  props: {
    featuredImages: {
      type: Array,
      default: () => [],
    },
    bucket: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imgPlaceholder,
      flickityOptions: {
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        initialIndex: 0,
        draggable: '>1',
        pauseAutoPlayOnHover: true,
        groupCells: 1,
      },
      clicked_index: -1,
      carousel_loaded: false,
    };
  },
  beforeMount() {
    this.carouselWidthCheck();
    log.info(this.featuredImages);
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.bucketItems = this.bucket.items;
      this.bucketData = { ...this.bucket };
      this.bucketData.items = [];
      this.bucketData.position = this.$vnode.key;
      this.bucketData.items_count = this.bucket.items.length;

      this.clickCarousel();
      this.carouselSettled();
    },
    clickCarousel() {
      this.$nextTick().then(() => {
        if (!this.featuredImages.length) return;
        this.$refs.flickity.on('staticClick', (event, pointer, cellElement, cellIndex) => {
          this.clicked_index = cellIndex;
          this.$router.push(`/listen/${this.featuredImages[cellIndex].publisher.slug}/${this.featuredImages[cellIndex].slug}/${this.featuredImages[cellIndex].uuid}`);
          this.carousel_loaded = true;
          this.triggerSegmentContentSelectEvent(this.featuredImages[cellIndex], cellIndex);
        });
      }).catch((err) => { log.warn(err.message); });
    },
    carouselSettled() {
      this.$refs.flickity.on('settle', () => {
        this.triggerSegmentContentViewedEvent();
      });
    },
    carouselWidthCheck() {
      this.flickityOptions.pageDots = this.currentScreenWidth <= this.screenSize.sm;
    },
  },
};
</script>
<style lang="scss">
.featured-carousel {
  .img-container {
    height: 427px;
    width: 712px;
    background-color: #ddd;
    margin-right: 16px;
    position: relative;
    .featured-content {
      position: absolute;
      left: 0px;
      bottom: 0px;
      width: 96.5%;
      padding: 40px 0 25px 25px;
      background: linear-gradient(180deg, rgba(17,17,17,0) 0%, rgba(17,17,17,0.6) 100%);
      .premier {
        font-size: 14px;
        color: #fff;
        margin: 0 0;
      }
      .show_name {
        font-size: 20px;
        line-height: 24px;
        height: 25px;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0 0;
        color: #fff;
      }
    }
  }
}
@media (max-width : 1024px) {
  .featured-carousel {
    .img-container {
      width: 591px;
      height: 354px !important;
    }
  }
}
@media (max-width: 768px) {
  .featured-carousel {
    .img-container {
      width : 507px;
      height: 304px !important;
    }
  }
}
@media (max-width: 576px) {
  .featured-carousel {
    .img-container {
      height: 284px !important;
      width: 100% !important;
      margin:0 !important;
      .featured-content {
        padding: 5px 15px 15px 15px;
      }
    }
  }
}
@media (max-width : 375px) {
  .featured-carousel {
    .img-container {
      height: 225px !important;
    }
  }
}
@media (min-width: 576px) {
  .mt16 {
    margin-top: 16px !important;
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/FeaturedCarousel.vue